// components/super-admin-only/SuperAdminOnly.tsx
// Route guard that allows access only to users with the Super.admin role.
import useSession from '@hooks/useSession';
import NotFound from '@components/not-found/NotFound';

interface SuperAdminOnlyProps {
  readonly children: React.ReactNode;
}

const SuperAdminOnly = ({ children }: SuperAdminOnlyProps) => {
  const { isSuperAdmin, loading } = useSession();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isSuperAdmin) {
    return <NotFound />;
  }

  return <>{children}</>;
};

export default SuperAdminOnly;
